import { CalciteAlert } from 'components/Calcite';
import styled from 'styled-components';

export const StyledCalciteAlert = styled(CalciteAlert)`
  z-index: ${({ theme }) => theme.zIndex.modalOverlayContent};
`;
